import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    content: '',
  },
};

export const htmlSlice = createSlice({
  name: 'html',
  initialState,
  reducers: {
    htmlStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent } = block;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.blockContent = {
        content: blockContent.content ?? '',
      };
    },
    htmlClear: () => initialState,

    htmlUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    htmlUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    htmlUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { htmlStore, htmlClear, htmlUpdateIsLoading, htmlUpdateIsActive, htmlUpdateBlockContent } = htmlSlice.actions;

export const selectHTMLIsLoading = (state) => state.html.isLoading;

export const selectHTMLId = (state) => state.html.id;
export const selectHTMLUID = (state) => state.html.uid;
export const selectHTMLSID = (state) => state.html.sid;

export const selectHTMLBlockContent = (state) => state.html.blockContent;

export default htmlSlice.reducer;
